import { ScheduleRequest } from '@weave/schema-gen-ts/dist/schemas/schedule/api/v2/api.pb';
import { DataSourcesQueries } from '@frontend/api-data-sources';
import { useDevToolsStore } from '@frontend/devtools';
import { ContentLoader } from '@frontend/design-system';
import { useManageAppointmentWriteback } from '../../../../../../hooks/scheduler-v3/use-manage-appointment-writeback';
import { ScheduleActionsContext, ScheduleActionsContextType } from '../../ScheduleActionsContext';
import { ScheduleRequestModalContext, ScheduleRequestModalContextType } from '../Context/ScheduleRequestModalContext';
import { ScheduleRequestModal } from '../ScheduleRequestModal';
import { ScheduleReadOnlyRequestModal } from '../ScheduleRequestModal/ScheduleReadOnlyRequestModal/ScheduleReadOnlyRequestModal';
import { ScheduleRequestContentWrapper } from '../ScheduleRequestModal/types';

type ScheduleRequestFormManagerProps = {
  scheduleRequestModalContextValue: ScheduleRequestModalContextType;
  selectedScheduleRequest: ScheduleRequest;
  wrapper: ScheduleRequestContentWrapper;
  scheduleActionsContextValue: ScheduleActionsContextType;
};
export const ScheduleRequestFormManager = ({
  wrapper: Wrapper,
  scheduleRequestModalContextValue,
  selectedScheduleRequest,
  scheduleActionsContextValue,
}: ScheduleRequestFormManagerProps) => {
  const locationId = selectedScheduleRequest.locationId ?? '';

  const { isIntegratedOffice, isLoading: isLoadingIntegrationDetails } =
    DataSourcesQueries.useGetAccessibleIntegrations();

  const { appointmentWritebackSourceTenants, isLoadingDataSources, isLoadingSourceTenants } =
    useManageAppointmentWriteback({
      isEnabled: isIntegratedOffice,
      locationId: locationId,
    });

  const isLoading = isLoadingIntegrationDetails || isLoadingDataSources || isLoadingSourceTenants;

  const isIntegratedWithoutWritebacks = isIntegratedOffice && !appointmentWritebackSourceTenants.length;

  const {
    options: { isDebugModeOn },
  } = useDevToolsStore();

  return (
    <>
      {isLoading ? (
        <ContentLoader />
      ) : (
        <ScheduleActionsContext.Provider value={scheduleActionsContextValue}>
          <ScheduleRequestModalContext.Provider value={scheduleRequestModalContextValue}>
            {isIntegratedWithoutWritebacks && !isDebugModeOn ? (
              <ScheduleReadOnlyRequestModal wrapper={Wrapper} />
            ) : (
              <ScheduleRequestModal
                wrapper={Wrapper}
                showWritebackWarning={isIntegratedWithoutWritebacks && isDebugModeOn}
              />
            )}
          </ScheduleRequestModalContext.Provider>
        </ScheduleActionsContext.Provider>
      )}
    </>
  );
};
